module.exports = __webpack_public_path__ + "static/media/laveasmaos.4622d5d0.png";